import { Grid, Tooltip, Typography } from '@material-ui/core';
import { DefaultCard } from '../components/default-card';
import { useDefaultCardStyles } from '../components/default-card/default-card-styles';
import { CardIndicacaoRevendedorProps } from './card-indicacao-revendedor-props';
import { useStyles } from '../../dialog/dialog-filial/dialog-filial-styles'
import { formatarCPFCNPJ } from 'utils/cpfcnpj-format';
import { useThemeQueries } from 'views/theme';
import { memo, useCallback } from 'react';
import { EnumStatusIndicacaoRevendedor } from 'data/api/gestao/indicacao-revendedores/get-indicacao-revendedores';
import { EditarIcon } from 'views/components/icons';


export const CardIndicacaoRevendedor = memo(({
  model,
  onClick
}: CardIndicacaoRevendedorProps) => {
  const classes = useDefaultCardStyles();
  const dialogClasses = useStyles();
  const { theme: { palette }, isMobile } = useThemeQueries()

  const statusColor = useCallback(() => {
    switch (model.status) {
      case EnumStatusIndicacaoRevendedor.Aprovado:
        return palette.success.main
      case EnumStatusIndicacaoRevendedor.Pendente:
        return palette.warning.main
      case EnumStatusIndicacaoRevendedor.Rejeitado:
        return palette.error.main
    }
  }, [model.status, palette.error.main, palette.success.main, palette.warning.main])

  return (
    <>
      <DefaultCard
        className={dialogClasses.noPosition}
        onClick={() => onClick(model.id)}
      >
        <Tooltip title={EnumStatusIndicacaoRevendedor[model.status]} placement='right'>
          <div style={{
            backgroundColor: statusColor(),
            width: '5px',
            borderRadius: '5px',
            alignSelf: 'stretch',
            margin: '7px'
          }} />
        </Tooltip>
        <div className={classes.cardContent}>
          <Grid container spacing={isMobile ? 1 : 2}>
            <Grid item xs={"auto"}>
              <Typography color="textPrimary" variant="caption">
                CNPJ
              </Typography>
              <Typography
                color="textPrimary"
                variant="body2"
              >
                <b>{formatarCPFCNPJ(model.cnpj)}</b>
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <Typography color="textPrimary" variant="caption">
                Nome
              </Typography>
              <Typography
                color="textPrimary"
                variant="body2"
              >
                {model.nome}
              </Typography>
            </Grid>
            <Grid item xs >
              <Typography color="textPrimary" variant="caption">
                Telefone
              </Typography>
              <Typography
                color="textPrimary"
                variant="body2"
              >
                {model.telefone}
              </Typography>
            </Grid>
          </Grid>
        </div>
        <Tooltip arrow title="Editar Plano">
          <div className={classes.cardRightButton} style={{ marginLeft: '10px' }}>
            <EditarIcon tipo="BUTTON" fill={palette.primary.main} />
          </div>
        </Tooltip>
      </DefaultCard>
    </>
  );
});

CardIndicacaoRevendedor.displayName = "CardIndicacaoRevendedor"
